module.exports = __webpack_public_path__ + "advanced6.png?d780cfae2d1b4ae41d4f353eaaa6752b";